import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

const bosses = [
  { name: 'Procrastinazione', desc: 'Ruba tempo. Ti fa rimandare anche ciò che conta.', color: '#8b5cf6', threat: 85 },
  { name: 'Stress cronico', desc: 'Consuma energia e rende tutto più pesante.', color: '#ef4444', threat: 78 },
  { name: 'Dopamina distrutta', desc: 'Ti tiene attaccato a stimoli rapidi e piaceri vuoti.', color: '#f59e0b', threat: 92 },
  { name: 'Ansia sociale', desc: 'Ti isola anche quando vorresti esserci.', color: '#67e8f9', threat: 70 },
  { name: 'Zero energia', desc: 'Non è sempre pigrizia. Spesso è un sistema nervoso e saturo.', color: '#6b7280', threat: 65 },
  { name: 'Safe zone', desc: 'Sembra un rifugio ma diventa una prigione.', color: '#10b981', threat: 88 },
]

function BossCard({ boss, index }) {
  const cardRef = useRef(null)
  const isInView = useInView(cardRef, { once: true, margin: '-50px' })

  const handleMouseMove = (e) => {
    const card = cardRef.current
    if (!card) return
    const rect = card.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top
    const cx = rect.width / 2
    const cy = rect.height / 2
    card.style.transform = `perspective(1000px) rotateX(${(y - cy) / 14}deg) rotateY(${(cx - x) / 14}deg) scale3d(1.02,1.02,1.02)`
  }
  const handleMouseLeave = () => {
    const card = cardRef.current
    if (card) card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale3d(1,1,1)'
  }

  return (
    <motion.div
      ref={cardRef}
      className="manga-panel rounded-xl p-6 cursor-pointer relative overflow-hidden group"
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ transition: 'transform 0.15s ease-out, border-color 0.3s ease, box-shadow 0.3s ease' }}
    >
      <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
        style={{ boxShadow: `inset 0 0 25px ${boss.color}18, 0 0 35px ${boss.color}12` }}
      />
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-3">
          <div className="w-3 h-3 rounded-full" style={{ background: boss.color, boxShadow: `0 0 10px ${boss.color}` }} />
          <span className="text-[9px] text-nerd-gray uppercase tracking-wider font-display">Boss {String(index + 1).padStart(2, '0')}</span>
        </div>
        <h3 className="font-display text-lg font-bold text-nerd-white mb-2">{boss.name}</h3>
        <p className="text-nerd-gray text-sm leading-relaxed mb-4">{boss.desc}</p>
        <div className="flex items-center gap-2">
          <span className="text-[9px] text-nerd-gray uppercase tracking-wider font-display">Livello minaccia</span>
          <div className="flex-1 h-1.5 bg-nerd-dark rounded-full overflow-hidden">
            <div className="h-full rounded-full" style={{ width: `${boss.threat}%`, background: `linear-gradient(90deg, ${boss.color}60, ${boss.color})` }} />
          </div>
          <span className="text-[10px] font-display" style={{ color: boss.color }}>{boss.threat}</span>
        </div>
      </div>
    </motion.div>
  )
}

export default function BossSection() {
  const sectionRef = useRef(null)
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' })

  return (
    <section id="boss" ref={sectionRef} className="relative w-full py-12 md:py-18 px-4" style={{ background: '#050510' }}>
      <div className="max-w-6xl mx-auto">
        <motion.div className="text-center mb-14"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-nerd-white mb-4">
            Ogni storia ha i suoi{' '}
            <span className="text-gradient">boss.</span>
          </h2>
          <p className="text-nerd-gray text-base md:text-lg max-w-xl mx-auto">
            Questi sono quelli che bloccano più spesso la vita reale.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {bosses.map((b, i) => (
            <BossCard key={b.name} boss={b} index={i} />
          ))}
        </div>
      </div>
    </section>
  )
}
